import { render, staticRenderFns } from "./TDA-G10.vue?vue&type=template&id=6b9a5520&scoped=true"
import script from "./TDA-G10.vue?vue&type=script&lang=js"
export * from "./TDA-G10.vue?vue&type=script&lang=js"
import style0 from "./TDA-G10.vue?vue&type=style&index=0&id=6b9a5520&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a5520",
  null
  
)

export default component.exports